import { FC } from 'react';
import styled from '@emotion/styled';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'next-i18next';
import { pgEnableAtom } from 'src/stores/vip/atoms';
const Root = styled.div`
  padding: 0 8px;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  padding-bottom: 24px;
  margin-top: 32px;
  color: ${({
  theme
}) => theme.color.content9};
`;
const Wrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;
const Padding = styled.div`
  min-width: 16px;
`;
const Inner = styled.ul`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: auto;
  margin: 0px;
  padding: 0px;
  padding-bottom: 24px;
`;
const Row = styled.li`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-indent: 0px;
  color: ${({
  theme
}) => theme.color.content9};

  a {
    color: inherit;
  }
`;
const Title = styled.div`
  margin-bottom: 12px;
`;
interface Props {
  refundPolicyText: string;
}
const Terms: FC<Props> = ({
  refundPolicyText
}) => {
  const {
    t
  } = useTranslation();
  const pgEnable = useAtomValue(pgEnableAtom);
  return <Root data-sentry-element="Root" data-sentry-component="Terms" data-sentry-source-file="Terms.tsx">
      <Title data-sentry-element="Title" data-sentry-source-file="Terms.tsx">{t('vipsystem_main_notice_title')}</Title>
      <Wrap data-sentry-element="Wrap" data-sentry-source-file="Terms.tsx">
        <Padding data-sentry-element="Padding" data-sentry-source-file="Terms.tsx" />
        <Inner data-sentry-element="Inner" data-sentry-source-file="Terms.tsx">
          {t('vipsystem_main_notice').split('\n').map((text, i) => <Row key={i}>{text}</Row>)}
          {pgEnable && <Row>{t('vipsystem_main_notice_pg')}</Row>}
          {!!refundPolicyText.length && <Row dangerouslySetInnerHTML={{
          __html: t(refundPolicyText).replace(/\\n/gi, '<br />')
        }} />}
        </Inner>
      </Wrap>
    </Root>;
};
export default Terms;